import { useQuery, UseQueryOptions } from 'react-query';
import { getRequestReasonValues } from 'RestAPIs/request-reason';

const useGetRequestReason = (options?: UseQueryOptions<any, unknown, any>) => {
  const { data, isFetching, isError, refetch } = useQuery({
    queryKey: ['requestReason', 'list'],
    queryFn: async () => {
      const { data } = await getRequestReasonValues();
      return data;
    },
    ...options
  });
  return { data, isFetching, isError, refetch };
};

export default useGetRequestReason;
